import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{
        "className": "language-c"
      }}>{`PostHog::identify(array(
  'distinctId' => 'user:123',
  'properties' => array(
    'email' => 'john@doe.com',
    'proUser' => false
  )
));
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      